/**
 * @generated SignedSource<<e6eb46367287aa1322f15c3f4f7454fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorBioAuthor$data = {
  readonly bio: string | null | undefined;
  readonly " $fragmentType": "authorBioAuthor";
};
export type authorBioAuthor$key = {
  readonly " $data"?: authorBioAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorBioAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorBioAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "60df5b2a5058742c275bf14e27bad323";

export default node;
